/* eslint-disable no-magic-numbers, class-methods-use-this */

export default class Kick {

	_audio = null;

	constructor(audio) {
		this._audio = audio;
	}

	defaultOpts() {
		return {
			Δt: 0,
			velocity: 0,
			spectrum: [],
			decay: 0.01
		};
	}

	/* spectrum is array of frequencies or { root, harmonics } */
	play({ Δt, velocity, spectrum, decay }) {
		const audio = this._audio;

		if (velocity <= 0) {
			return;
		}

		const time = audio.currentTime + Δt;

		const gain = audio.createGain();

		gain.connect(audio.destination);

		gain.gain.setValueAtTime(velocity / spectrum.length, time);
		gain.gain.exponentialRampToValueAtTime(0.01, time + decay);

		if (spectrum instanceof Array) {
			void 0;
		} else if (spectrum.harmonics && spectrum.root) {
			const { root, harmonics } = spectrum;
			spectrum = [];
			for (let i = 1; i <= harmonics; i++) {
				spectrum.push(root * i);
			}
		}

		const osc = spectrum.map(f => {
			const o = audio.createOscillator();
			o.connect(gain);
			o.frequency.setValueAtTime(f, time);
			o.frequency.exponentialRampToValueAtTime(0.01, time + decay);
			return o;
		});

		osc.forEach(o => {
			o.start(time);
			o.stop(time + decay);
		});
	}

}
